<template>
    <div class="left-menu">
      <div v-for="(group, groupIndex) in leftMenuItems"  :key="groupIndex" class="menu-group">
        <div class="group-title">
          <span v-show="pageLanguage == 'zh'">{{ group.titleZh }}</span>
          <span v-show="pageLanguage == 'en'">{{ group.titleEn }}</span>
        </div>
        <div v-for="(item, itemIndex) in group.children" :key="itemIndex" class="menu-item" :class="{ active: activeMenuId === item.id.toString() }" @click="layOutChange(item)"> 
          <span v-show="pageLanguage == 'zh'"> {{ item.nameZh }}</span>
          <span v-show="pageLanguage == 'en'"> {{ item.nameEn }}</span>
        </div>
      </div>
    </div>
</template>

<script>

export default {
  name: 'layout',
  props: {
    activeMenuId: {
      type: String,
      default: '1101'
    },
    pageLanguage: {
      type: String,
      default:'en'
    },
    leftMenuItems: {
      type: Array,
      default:[]
    }
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    // 菜单点击
    layOutChange(item) {
      this.$emit('menuChange',item)
    }
  }
};
</script>
<style>
/* 左侧菜单样式 */
.left-menu {
  height: 100%;
  float: left;
  width: 200px;
  padding-bottom:50px;
  min-height: calc(100vh - 160px);
  color: #262626;
  font-size: 0.875rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  overflow-y: scroll;
}

.menu-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.group-title {
  font-size: 0.875rem;
  font-weight: 600;
  color: #333333;
  margin-bottom: 0.25rem;
}

.menu-item {
  padding: 0.5rem 0.75rem;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.2s;
  font-size: 0.875rem;
}
.menu-item.active {
  background: #e6f2ff;
  color: #0251ff;
  font-weight: 500;
}

.menu-item:hover {
  background: #f6faff;
  color: #0251ff;
}

.menu-item.active {
  background: #e6f2ff;
  color: #0251ff;
  font-weight: 500;
}
</style>